import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { Lang, t } from "../i18n/translations";

interface Props {
  lang: Lang;
  onToggleLang: () => void;
  variant?: "home" | "support";
}

export default function Navbar({ lang, onToggleLang, variant = "home" }: Props) {
  const tr = t[lang].nav;

  return (
    <nav className="navbar">
      <Link className="navbar-logo" to="/">
        <img src={logo} alt="MyLittleMouse" className="navbar-logo-img" />
        <span className="navbar-logo-name">MyLittleMouse</span>
      </Link>
      <div className="navbar-actions">
        {variant === "support" ? (
          <Link className="btn btn-outline" to="/">
            {lang === "pt" ? "← Home" : "← Home"}
          </Link>
        ) : (
          <>
            <button className="lang-toggle" onClick={onToggleLang}>
              {lang === "pt" ? "EN" : "PT"}
            </button>
            <Link className="btn btn-support" to={lang === "pt" ? "/apoie" : "/support"}>
              {tr.support}
            </Link>
            <a className="btn btn-outline" href="#download">{tr.download}</a>
            <a className="btn btn-primary" href="https://chromewebstore.google.com/detail/mylittlemouse/jcnbmdeefpiiennndfooadajlloochcp?hl=pt-BR&utm_source=ext_sidebar" target="_blank" rel="noreferrer">{tr.addToChrome}</a>
          </>
        )}
      </div>
    </nav>
  );
}
